export function groupBy(arr, key) {
  return arr.reduce((r, a) => {
    r[a[key]] = [...(r[a[key]] || []), a]
    return r
  }, {})
}
export function splitFill(value, splitChar = '.', fillChar = '&nbsp;&nbsp;') {
  const splits = value.split(splitChar)
  return new Array(splits.length).join(fillChar) + splits[splits.length - 1]
}
